"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _utils = require("@alycecom/utils");

var _recipientDetails = require("../../../Shapes/recipientDetails.shape");

var _recipient = require("../../store/recipient/recipient.actions");

var _recipient2 = require("../../store/recipient/recipient.selector");

var _contacts = require("../../store/contacts/contacts.actions");

var _EmailMayBounceConfirmation = _interopRequireDefault(require("../../components/EmailMayBounceConfirmation/EmailMayBounceConfirmation"));

var _UnsubscribedRecipientConfirmation = _interopRequireDefault(require("../../components/UnsubscribedRecipientConfirmation"));

var _StartBulkCreate = _interopRequireDefault(require("../../components/StartBulkCreate/StartBulkCreate"));

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _user = require("../../shapes/user.shape");

var _contacts2 = require("../../store/contacts/contacts.selectors");

var _RecipientDetailsForm = _interopRequireDefault(require("./RecipientDetailsForm"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ADD_CONTACT_FLOW = 'ADD_CONTACT';
var SEARCH_CONTACT_FLOW = 'SEARCH_CONTACT';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: "".concat(theme.spacing(3, 2)),
      margin: theme.spacing(2)
    },
    buttonIcon: {
      marginRight: theme.spacing(1),
      color: 'inherit'
    },
    disabled: {
      pointerEvents: 'none',
      opacity: 0.5
    },
    autocompleteOption: {
      padding: 0
    },
    autocompleteInput: {
      paddingTop: "".concat(theme.spacing(1 / 2), " !important"),
      paddingBottom: "".concat(theme.spacing(1 / 2), " !important")
    },
    addPersonIcon: {
      color: theme.palette.link.main,
      marginRight: theme.spacing(1)
    },
    backButton: {
      marginBottom: theme.spacing(1)
    }
  };
});
var getConfirmationWidth = R.pipe(R.pathOr(400, ['current', 'offsetWidth']), R.ifElse(R.lt(400), R.always(600), R.always(400)));
var getContactsFilter = R.pipe(R.pick(['firstName', 'lastName', 'email', 'employment']), _utils.pickNotEmptyAndNil);

var RecipientDetailsCreate = function RecipientDetailsCreate(_ref) {
  var onBulkCreate = _ref.onBulkCreate,
      onClose = _ref.onClose,
      hasInternational = _ref.hasInternational,
      initialRecipientData = _ref.initialRecipientData,
      forceCreateRecipientFlow = _ref.forceCreateRecipientFlow,
      sidebarMode = _ref.sidebarMode,
      user = _ref.user,
      campaignId = _ref.campaignId;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(_recipient2.getRecipientIsLoading);
  var isEmailValid = (0, _reactRedux.useSelector)(_recipient2.gerRecipientEmailIsValid);
  var isUnsubscribed = (0, _reactRedux.useSelector)(_recipient2.gerRecipientIsUnsubscribed);
  var errors = (0, _reactRedux.useSelector)(_recipient2.getRecipientErrors);
  var isContactsLoading = (0, _reactRedux.useSelector)(_contacts2.getContactsIsLoading);
  var contacts = (0, _reactRedux.useSelector)(_contacts2.getContactsList);

  var _useState = (0, _react.useState)(_objectSpread(_objectSpread({}, (0, _recipientDetails.createEmptyRecipient)('')), initialRecipientData)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      recipient = _useState2[0],
      setRecipient = _useState2[1];

  var _useState3 = (0, _react.useState)(forceCreateRecipientFlow ? ADD_CONTACT_FLOW : SEARCH_CONTACT_FLOW),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      currentFlow = _useState4[0],
      setFlow = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isCreatingContact = _useState6[0],
      setIsCreatingContact = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      replaceEmail = _useState8[0],
      setReplaceEmail = _useState8[1];

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var trackContactSelected = (0, _useTrackGiftingFlow.useTrackContactSelected)(user);
  var handleSubmit = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    setReplaceEmail(false);
    trackEvent('Gifting flow - clicked create new contact');
    dispatch((0, _recipient.createRecipientRequestTry)(recipient));
  }, [dispatch, recipient, trackEvent]);
  var handleContinueButton = (0, _react.useCallback)(function () {
    trackContactSelected('available contacts');
    dispatch((0, _recipient.createRecipientSuccess)(recipient));
  }, [recipient, dispatch, trackContactSelected]);
  var onBulkCreateHandler = (0, _react.useCallback)(function () {
    trackEvent('Gifting flow - clicked bulk upload a list');
    onBulkCreate();
  }, [onBulkCreate, trackEvent]);
  (0, _react.useEffect)(function () {
    dispatch((0, _recipient.createRecipientEmailValid)());
  }, [dispatch, recipient.email]);
  var searchContacts = (0, _react.useCallback)(function (searchData) {
    var shouldSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var filters = getContactsFilter(searchData);
    var hasFilters = (0, _utils.hasKeys)(filters);

    if (shouldSearch && hasFilters) {
      dispatch((0, _contacts.setContactsFilters)(filters));
    }

    if (shouldSearch && !hasFilters) {
      dispatch((0, _contacts.resetContacts)());
    }
  }, [dispatch]);
  var handleSelectContact = (0, _react.useCallback)(function (contact) {
    var selectedContact = {
      firstName: contact.first_name,
      lastName: contact.last_name,
      employment: contact.company,
      country: contact.country_id,
      email: contact.email,
      employmentPosition: contact.position
    };
    setRecipient(selectedContact);
    setIsCreatingContact(false);
  }, [setRecipient, setIsCreatingContact]);
  var setFlowSearchContact = (0, _react.useCallback)(function () {
    setFlow(SEARCH_CONTACT_FLOW);
    searchContacts(recipient, true);
  }, [recipient, searchContacts]);
  var handleSearchContact = (0, _react.useCallback)(function (fieldName, fieldValue) {
    var recipientValues = _objectSpread(_objectSpread({}, recipient), {}, {
      [fieldName]: fieldValue
    });

    setRecipient(recipientValues);
    dispatch((0, _recipient.createRecipientResetErrors)());
    var isSearchFlow = currentFlow === SEARCH_CONTACT_FLOW && fieldValue.length > 1;

    if (fieldName === 'email') {
      searchContacts(recipientValues, isSearchFlow);
    }
  }, [dispatch, recipient, currentFlow, searchContacts]);
  var handleClearEmail = (0, _react.useCallback)(function () {
    setRecipient(_objectSpread({}, (0, _recipientDetails.createEmptyRecipient)('')));
    setIsCreatingContact(true);
    dispatch((0, _recipient.createRecipientResetErrors)());
  }, [dispatch, setRecipient, setIsCreatingContact]);
  var handleUpdateContact = (0, _react.useCallback)(function (changes) {
    var recipientValues = _objectSpread(_objectSpread({}, recipient), changes);

    setRecipient(recipientValues);
    dispatch((0, _recipient.createRecipientResetErrors)());
  }, [dispatch, recipient]);
  var showEmailWarning = !replaceEmail && !isEmailValid && !isUnsubscribed;
  var isBulkModeVisible = !!onBulkCreate;
  (0, _react.useEffect)(function () {
    return function () {
      return dispatch((0, _contacts.resetContacts)());
    };
  }, [dispatch]);

  var recipientForm = /*#__PURE__*/_react.default.createElement(_RecipientDetailsForm.default, {
    disabled: isLoading,
    onSubmit: handleSubmit,
    recipient: recipient,
    campaignId: campaignId,
    contacts: contacts,
    isContactsLoading: isContactsLoading,
    errors: errors,
    hasInternational: hasInternational,
    onUpdateSearchField: handleSearchContact,
    onUpdateField: handleUpdateContact,
    onSelectContact: handleSelectContact,
    onClearSearch: handleClearEmail,
    renderActions: function renderActions() {
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        display: "flex",
        justifyContent: "flex-end",
        minHeight: 52
      }, isCreatingContact ? /*#__PURE__*/_react.default.createElement(_material.Button, {
        type: "submit",
        color: "secondary",
        variant: "contained",
        disabled: isLoading,
        className: classes.button,
        onClick: handleSubmit
      }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
        icon: "arrow-right",
        color: "primary",
        className: classes.buttonIcon,
        "data-testid": "GiftingFlow.RecipientsDetails.CreateNewContact"
      }), "Create new contact") : /*#__PURE__*/_react.default.createElement(_material.Button, {
        type: "submit",
        color: "secondary",
        variant: "contained",
        disabled: isLoading,
        className: classes.button,
        onClick: handleContinueButton,
        "data-testid": "GiftingFlow.RecipientsDetails.Continue"
      }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
        icon: "arrow-right",
        color: "primary",
        className: classes.buttonIcon
      }), "Continue"));
    }
  });

  var searchFlow = /*#__PURE__*/_react.default.createElement(_material.Slide, {
    in: currentFlow === SEARCH_CONTACT_FLOW,
    direction: "left"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Who are you sending this invite to?")), recipientForm, isBulkModeVisible && /*#__PURE__*/_react.default.createElement(_StartBulkCreate.default, {
    onBulkCreate: onBulkCreateHandler
  })));

  var addContactFlow = /*#__PURE__*/_react.default.createElement(_material.Slide, {
    in: currentFlow === ADD_CONTACT_FLOW,
    direction: "left"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, !forceCreateRecipientFlow && /*#__PURE__*/_react.default.createElement(_ui.FlatButton, {
    className: classes.backButton,
    icon: "arrow-left",
    onClick: setFlowSearchContact
  }, "Back to contact search"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Ok, let`s add a new contact!"), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 3,
    mb: 2
  }), recipientForm));

  var paperEl = (0, _react.useRef)(null);
  var confirmationWidth = sidebarMode ? getConfirmationWidth(paperEl) : '100%';
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    className: classes.root,
    ref: paperEl
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentFlow === SEARCH_CONTACT_FLOW && searchFlow, currentFlow === ADD_CONTACT_FLOW && addContactFlow, /*#__PURE__*/_react.default.createElement(_EmailMayBounceConfirmation.default, {
    isOpen: showEmailWarning,
    email: recipient.email,
    width: confirmationWidth,
    onSubmit: (0, _react.useCallback)(function () {
      return dispatch((0, _recipient.createRecipientRequest)(recipient));
    }, [dispatch, recipient]),
    onDiscard: (0, _react.useCallback)(function () {
      return setReplaceEmail(true);
    }, [])
  }), /*#__PURE__*/_react.default.createElement(_UnsubscribedRecipientConfirmation.default, {
    isOpen: isUnsubscribed,
    email: recipient.email,
    width: confirmationWidth,
    onSubmit: (0, _react.useCallback)(function () {
      dispatch((0, _recipient.createRecipientSetIsUnsubscribed)(false));
      onClose();
    }, [dispatch, onClose]),
    onDiscard: (0, _react.useCallback)(function () {
      dispatch((0, _recipient.createRecipientSetIsUnsubscribed)(false));
      setRecipient((0, _recipientDetails.createEmptyRecipient)(''));
    }, [dispatch])
  })));
};

RecipientDetailsCreate.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  onBulkCreate: _propTypes.default.func,
  initialRecipientData: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    employment: _propTypes.default.string,
    email: _propTypes.default.string
  }).isRequired,
  forceCreateRecipientFlow: _propTypes.default.bool.isRequired,
  sidebarMode: _propTypes.default.bool.isRequired,
  hasInternational: _propTypes.default.bool,
  user: _user.User.isRequired,
  campaignId: _propTypes.default.number
};
RecipientDetailsCreate.defaultProps = {
  hasInternational: false,
  onBulkCreate: null,
  campaignId: undefined
};
var _default = RecipientDetailsCreate;
exports.default = _default;